import crud from '@/crud/index/index'
import resources from '../../resources'

import computed from './computed'
import methods from './methods'

export default {
  computed,
  methods,

  mixins: [crud, resources]
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/locks/index/resources/index.js